'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _awsSdk = require('aws-sdk');

var _awsSdk2 = _interopRequireDefault(_awsSdk);

var _ContactForm = require('../ContactForm');

var _ContactForm2 = _interopRequireDefault(_ContactForm);

var _Image = require('../../atoms/Image');

var _Image2 = _interopRequireDefault(_Image);

var _FishermanLogoNoText = require('./Fisherman-Logo-NoText.png');

var _FishermanLogoNoText2 = _interopRequireDefault(_FishermanLogoNoText);

require('./sign-up-banner.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var params = function params(name, email, website) {
  return {
    Destination: { /* required */
      ToAddresses: ['info@fishrmn.com']
    },
    Message: { /* required */
      Body: { /* required */
        Text: {
          Charset: "UTF-8",
          Data: name + " (" + email + ") " + "has claimed the website: " + website
        }
      },
      Subject: {
        Charset: 'UTF-8',
        Data: 'CLAIM REQUEST: ' + website
      }
    },
    Source: 'websiteclaim@fishrmn.com',
    ReplyToAddresses: ['info@fishrmn.com']
  };
};

var beforeHeader = "Is This Your Business? Claim Your Website Now!";
var beforeCopy = "Please submit your Name and Email Address and we will contact you to verify.";
var afterHeader = "Thank You! We will be in touch with you shortly.";
var afterCopy = "This banner will be removed from your website in a couple of minutes!";

var subscriptionCallback = function subscriptionCallback(website) {
  return function (name, email) {
    return new _awsSdk2.default.SES({ apiVersion: '2010-12-01' }).sendEmail(params(name, email, website)).promise();
  };
};

var SignUpBanner = function (_React$Component) {
  _inherits(SignUpBanner, _React$Component);

  function SignUpBanner() {
    _classCallCheck(this, SignUpBanner);

    var _this = _possibleConstructorReturn(this, (SignUpBanner.__proto__ || Object.getPrototypeOf(SignUpBanner)).call(this));

    _this.state = { submitted: false, website: '' };
    _this.submitSuccess = _this.submitSuccess.bind(_this);
    return _this;
  }

  _createClass(SignUpBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _awsSdk2.default.config.update({
        region: 'us-east-1',
        credentials: new _awsSdk2.default.Credentials(process.env.AWS_ACCESS_KEY_ID, process.env.AWS_SECRET_ACCESS_KEY)
      });
      if (typeof window !== "undefined") {
        this.setState({ website: window.location.hostname });
      }
    }
  }, {
    key: 'submitSuccess',
    value: function submitSuccess() {
      this.setState({ submitted: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          submitted = _state.submitted,
          website = _state.website;
      var claimed = this.props.claimed;

      return _react2.default.createElement(
        'div',
        { id: 'sign-up-banner', style: claimed ? { display: 'none' } : {} },
        _react2.default.createElement(
          'div',
          { id: 'sign-up-banner-top' },
          _react2.default.createElement(
            'div',
            { id: 'sign-up-banner-logo' },
            _react2.default.createElement(_Image2.default, { src: _FishermanLogoNoText2.default, alt: 'Fisherman Logo', height: 'auto', width: '60px' })
          ),
          _react2.default.createElement(
            'div',
            { id: 'sign-up-banner-content' },
            _react2.default.createElement(
              'div',
              { id: 'sign-up-banner-header' },
              submitted ? afterHeader : beforeHeader
            ),
            _react2.default.createElement(
              'div',
              { id: 'sign-up-banner-copy' },
              submitted ? afterCopy : beforeCopy
            )
          )
        ),
        _react2.default.createElement(_ContactForm2.default, {
          subscriptionCallback: subscriptionCallback(website),
          submissionCallback: this.submitSuccess,
          disabled: submitted,
          inline: true
        })
      );
    }
  }]);

  return SignUpBanner;
}(_react2.default.Component);

exports.default = SignUpBanner;


SignUpBanner.propTypes = {
  claimed: _propTypes2.default.bool
};

SignUpBanner.defaultProps = {
  claimed: false
};